import { useContext, useMemo } from 'react';
import SimpleBar from 'simplebar-react';
import classNames from 'classnames';
import moment from 'moment';

import {IEtfAssetBackend, IEtfDocumentBackend} from 'api/etf';

import { decodeSiteResolutionValue, SiteResolutionContext } from 'shared/mechanics/site-resolution';
import {ContentPanel, EtfLabel, TextButton} from 'shared/ui-kit';
import { ContentPanelTable, ContentPanelTablePropsColumn } from 'shared/ui-kit/panel/content-panel-table';
import { AdsComponent } from 'shared/components/ads';

import styles from "./content.module.scss";
import wNumb from "wnumb";
import {showAuthPopup} from "../../../../shared/auth";

const percentFormat = wNumb({ decimals: 2, suffix: '%' }).to;
const numberFormat = wNumb({ thousand: ' ' }).to;

export interface EtfAssetsPageContentProps {
	ticker: string;
	assets: IEtfAssetBackend[];
	isDataTruncated: boolean;
}
export const EtfAssetsPageContent = (props: EtfAssetsPageContentProps) => {
	const desktopConcreteDocumentTableColumns: ContentPanelTablePropsColumn<IEtfAssetBackend>[] = useMemo(
		() => [
			{ id: 'ticker', title: "Тикер", getValue: asset => asset.ticker ?? '-' },
			{ id: 'percent', title: "Вес", getValue: asset => asset.percent, renderCell: asset => percentFormat(asset.percent * 100), cellClassName: styles.column_percent },
			{ id: 'value', title: "Стоимость", getValue: asset => asset.value, renderCell: asset => numberFormat(asset.value), cellClassName: styles.column_number },
			{ id: 'quantity', title: "Кол-во", getValue: asset => asset.quantity, renderCell: asset => numberFormat(asset.quantity), cellClassName: styles.column_number },
			{ id: 'asset', title: "Наименовение", getValue: asset => asset.asset },
			{ id: 'isin', title: "ISIN", getValue: asset => asset.isin },
		],
		[]);
	const compactDocumentsTableColumns: ContentPanelTablePropsColumn<IEtfAssetBackend>[] = useMemo(
		() => [
			{
				id: 'doc',
				title: "Актив",
				getValue: asset => asset.asset,
				renderCell: asset => (
					<>
						<p>{ asset.asset }</p>
						<p>Вес: { percentFormat(asset.percent * 100) }</p>
						<p>Стоимость: { numberFormat(asset.value) }</p>
					</>
				)
			},
		],
		[]);
	
	const siteResolution = useContext(SiteResolutionContext);
	
	const concreteDocumentTableColumns = decodeSiteResolutionValue(siteResolution, desktopConcreteDocumentTableColumns, compactDocumentsTableColumns);

	const ads2Key = decodeSiteResolutionValue(siteResolution, 'InfoDetailedHorizontal2:desktop', 'InfoDetailedHorizontal2:mobile');
	
	return (
		<div className={classNames("flex-size-fill flex-container-vertical", styles.container)}>
			<div className={classNames("flex-size-least", styles.header)}>
				<h1>Состав фонда <EtfLabel ticker={props.ticker} /></h1>
			</div>
			<div className={classNames("flex-size-fill", styles.content)}>
				<SimpleBar style={{ width: '100%', height: '100%'}}>
					<ContentPanel title="Состав фонда" className={styles.item}>
						<ContentPanelTable columns={concreteDocumentTableColumns} rows={props.assets} />
						{
							props.isDataTruncated
								? (
									<p>
										<TextButton
											title="Раскрыть полный состав"
											onClick={() => showAuthPopup({ title: 'Раскрыть полный состав' })}></TextButton>
									</p>
								)
								: null
						}
					</ContentPanel>
					<div className={styles.item}>
						<AdsComponent id={ads2Key} isVertical={false} />
					</div>
				</SimpleBar>
			</div>
		</div>
	);
}